module.exports = __webpack_public_path__ + "img/add.46ea6b2f.svg";